import React, { Component } from 'react';
import { Route, Switch, withRouter ,Redirect} from 'react-router-dom';
import { connect } from 'react-redux';
import 'antd/dist/antd.css'; 

/* Page Containers */
import Mainpage from './mainpage/Mainpage';
import Login from './login/Login';
import Questions from './questions/Questions';
import Result from './result/Result';
import MainHistory from "./mainpage/MainHistory";
import MainJob from "./mainpage/MainJob";
import MainDisclaimer from "./mainpage/MainDisclaimer";

/* Components */
import Routing from '../components/routing/Routing';

import './app.css';


const ScrollToTopPage = () => {
	window.scrollTo(0, 0);
	return null;
};

class App extends Component {
  constructor(props) {
		super(props);
		this.state = {
      goLanding: true,
    }
  }

 

	render() {
    // const { goLanding } = this.state;
		// const pathName = this.props.router.location.pathname;
    const { userProfile } = this.props;
		const classMainContent = 'mainContent mainContentDefault';
    const PrivateRoute = ({ component: Component, isAuthenticated,  ...rest }) => {
      // console.log("route")
      return(
       <Route
        {...rest}

        render={props => (isAuthenticated&&localStorage.u ? 
          <Component {...props} /> 
          :
          (<Redirect to="/login" />)
        )}
      />
      )};

      const LoginRoute = ({ component: Component, isAuthenticated, ...rest }) => {
        // console.log(isAuthenticated)
  
        return(
        <Route
         {...rest}
  
         render={props => (isAuthenticated&&localStorage.u ?
          //*****************UPDATE TO MAIN */
           <Redirect to="/questions" />
           :
           <Component {...props} /> 
         )}
       />
  
     )};

		return (
			<div className="App">
        <Switch>
          <Route component={ScrollToTopPage}/>
        </Switch>
          <div className={classMainContent}>
            <Switch>
            <Route exact path="/" component={Mainpage} />
            <Route exact path="/history" component={MainHistory} ></Route>
            <Route exact path="/searchJob" component={MainJob}  ></Route>
            <Route exact path="/disclaimer" component={MainDisclaimer}  ></Route>
            <LoginRoute exact path="/login" component={Login} isAuthenticated={this.props.userAuthenticated} ></LoginRoute>
            <PrivateRoute exact path="/questions" component={Questions} isAuthenticated={this.props.userAuthenticated} ></PrivateRoute>
            <PrivateRoute exact path="/result" component={Result} isAuthenticated={this.props.userAuthenticated} ></PrivateRoute>

              {/* <Route component={ScrollToTopPage} /> */}
            </Switch>
          </div>
        {/* } */}
			</div>
		);
	}
}


const mapStateToProps = state => ({
	router: state.router,
	userAuthenticated: state.user.userAuthenticated,
	userProfile: state.user.userProfile
});

export default withRouter(connect(mapStateToProps)(App));
